import type { PaginatorDesignTokens } from '@primeuix/themes/types/paginator';

/**
 * Paginator component tokens
 * 
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/paginator/index.ts
 * 
 * Component documentation:
 * https://primeng.org/paginator
 */
export const paginatorComponentTokens: Partial<PaginatorDesignTokens> = {
  root: {
    background: 'transparent',
  },
};



